import { render } from "./index.vue?vue&type=template&id=b335918a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/apartment/dynamic/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b335918a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b335918a', __exports__)) {
    console.log('reload')
    api.reload('b335918a', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=b335918a", () => {
    console.log('re-render')
    api.rerender('b335918a', render)
  })

}


export default __exports__